var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProTraceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 11.6364,
    height: 10.5051,
    viewBox: "0 0 11.6364 10.5051",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427319334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6363 3.23046C11.6363 2.60601 11.0989 2.09518 10.4427 2.09518H8.55236V1.90254C8.55236 1.74045 8.4126 1.6076 8.24138 1.6076H8.12466V1.22764C8.12466 0.551389 7.54462 4.43892e-05 6.83322 4.43892e-05H4.8038C4.09168 4.43892e-05 3.51236 0.551412 3.51236 1.22764V1.6076H3.39496C3.22444 1.6076 3.08469 1.74047 3.08469 1.90254V2.09518H1.19431C0.537403 2.09518 0 2.60601 0 3.23046V5.94871C0 6.08652 0.0619887 6.21425 0.176365 6.332H0.176102V9.39104C0.176102 10.0042 0.703736 10.5051 1.34804 10.5051H10.2883C10.9333 10.5051 11.4609 10.0042 11.4609 9.39104V6.332H11.4601C11.5744 6.21425 11.6363 6.08652 11.6363 5.94871V3.23046ZM4.3195 1.6076H4.20211V1.22764C4.20211 0.913421 4.47255 0.656355 4.8038 0.656355H6.83322C7.16378 0.656355 7.43421 0.913444 7.43421 1.22764V1.6076H7.31751C7.14699 1.6076 7.00724 1.74047 7.00724 1.90254V2.09518H4.62981V1.90254C4.62981 1.74045 4.49003 1.6076 4.31953 1.6076H4.3195Z",
    fill: "#AD8873"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.4601 6.33197C11.1778 6.62288 10.5744 6.85269 9.78443 7.02149V7.16167C9.78443 7.26939 9.72302 7.36375 9.63213 7.41541H9.63278V7.75286C9.63278 7.88307 9.52024 7.99001 9.38329 7.99001H8.64043C8.50348 7.99001 8.39094 7.88307 8.39094 7.75286V7.41541H8.39159C8.32733 7.37888 8.27791 7.32091 8.25442 7.25207C6.72182 7.40797 4.91443 7.40794 3.38195 7.252C3.35846 7.32089 3.30904 7.37888 3.24476 7.41543H3.24612V7.75288C3.24612 7.88309 3.13359 7.99004 2.99592 7.99004H2.25306C2.11608 7.99004 2.00357 7.88309 2.00357 7.75288V7.41543H2.00448C1.9134 7.36377 1.85194 7.26941 1.85194 7.16169V7.02135C1.06232 6.85255 0.458833 6.62282 0.1764 6.33197H0.176136V9.39101C0.176136 10.0041 0.70377 10.505 1.34808 10.505H10.2883C10.9333 10.505 11.461 10.0042 11.461 9.39101V6.33197H11.4601Z",
    fill: "#846858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.16274 5.95931H3.08659C3.25711 5.95931 3.39687 6.09216 3.39687 6.25491V7.16166C3.39687 7.32442 3.25711 7.45726 3.08659 7.45726H2.16274C1.99153 7.45726 1.85177 7.32442 1.85177 7.16166V6.25491C1.85177 6.09216 1.99155 5.95931 2.16274 5.95931Z",
    fill: "#FCCE2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.54958 5.95931H9.47415C9.64467 5.95931 9.78443 6.09216 9.78443 6.25491V7.16166C9.78443 7.32442 9.64465 7.45726 9.47415 7.45726H8.54958C8.37906 7.45726 8.23931 7.32442 8.23931 7.16166V6.25491C8.23931 6.09216 8.37909 5.95931 8.54958 5.95931Z",
    fill: "#FCCE2C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    opacity: 0.3,
    d: "M11.4613 9.38583C11.4613 9.99884 10.9333 10.501 10.2884 10.5011H9.90563C10.5505 10.5008 11.0775 9.99979 11.0775 9.38681V7.36728C11.0775 7.19608 10.8963 7.07854 10.7289 7.14169C10.4605 7.24298 10.1417 7.33197 9.78453 7.40829L9.63317 7.43173V7.41513H9.63219C9.72297 7.36344 9.78453 7.26887 9.78453 7.16122V7.02158C10.5752 6.85259 11.1793 6.62243 11.4613 6.33115V9.38583ZM8.25426 7.25204C8.27775 7.32089 8.32769 7.3786 8.39196 7.41513H8.39098V7.62314L8.35192 7.629C6.76708 7.79838 4.8704 7.79836 3.28551 7.629L3.24645 7.62314V7.41513H3.2445C3.30878 7.37858 3.3587 7.32093 3.38219 7.25204C4.91458 7.40795 6.72179 7.40793 8.25426 7.25204ZM0.176136 6.33212C0.458535 6.62298 1.06218 6.85275 1.85192 7.02158V7.1622C1.85207 7.26962 1.9135 7.36349 2.00426 7.41513H2.00328V7.43173L1.85289 7.40829C1.06273 7.23943 0.458569 7.00984 0.176136 6.71884V6.33212Z",
    fill: "#5E4A3E"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.99387 4.4135H6.64242C6.8269 4.4135 6.97786 4.557 6.97786 4.73236C6.97786 4.90772 6.8269 5.05054 6.64242 5.05054H4.99387C4.80936 5.05054 4.65842 4.90772 4.65842 4.73236C4.65842 4.557 4.80936 4.4135 4.99387 4.4135Z",
    fill: "#846858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.62987 1.90251V2.09514H3.08473V1.90251C3.08473 1.74042 3.22448 1.60757 3.395 1.60757H4.31957C4.49009 1.60757 4.62985 1.74044 4.62985 1.90251H4.62987ZM8.24145 1.60757H7.3176C7.14708 1.60757 7.00732 1.74044 7.00732 1.90251V2.09514H8.55245V1.90251C8.55245 1.74042 8.41269 1.60757 8.24147 1.60757H8.24145Z",
    fill: "#FCCE2C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.5,
    d: "M4.31962 1.60758H4.13485C4.17685 1.65792 4.2022 1.72128 4.2022 1.79006V1.8557C4.2022 1.92584 4.14239 1.9827 4.0686 1.9827H3.08476V2.09515H4.6299V1.90251C4.6299 1.74029 4.49026 1.60758 4.31962 1.60758Z",
    fill: "#FCCE2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.5,
    d: "M8.24128 1.60758H8.05718C8.09923 1.65792 8.12458 1.72128 8.12458 1.79006V1.8557C8.12458 1.92584 8.06477 1.98269 7.99098 1.98269H7.00713V2.09515H8.55225V1.90251C8.55225 1.74042 8.4125 1.60758 8.24128 1.60758Z",
    fill: "#FCCE2C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.3,
    d: "M3.86695 1.2276V1.60756H4.20215V1.2276C4.20215 0.913381 4.47259 0.656314 4.80384 0.656314H4.46864C4.13739 0.656314 3.86695 0.913403 3.86695 1.2276Z",
    fill: "#846858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.3,
    d: "M6.8334 5.07946e-06H6.49819C7.20959 5.07946e-06 7.78964 0.551372 7.78964 1.2276V1.60756H8.12484V1.2276C8.12484 0.55135 7.54479 5.07946e-06 6.8334 5.07946e-06Z",
    fill: "#5E4A3E"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M10.4427 2.09515H10.0597C10.7159 2.09515 11.2533 2.65289 11.2533 3.33464V6.30246C11.2533 6.38164 11.236 6.45772 11.2032 6.53082C11.4797 6.36218 11.6364 6.16818 11.6364 5.94866V3.2304C11.6364 2.60596 11.099 2.09515 10.4427 2.09515Z",
    fill: "#846858"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.5,
    d: "M3.08691 7.45725H2.16307C2.1052 7.45725 2.05109 7.4418 2.00459 7.4154H2.00373V7.75285C2.00373 7.88306 2.11626 7.99001 2.25322 7.99001H2.99607C3.13375 7.99001 3.24628 7.88306 3.24628 7.75285V7.4154H3.24492C3.19851 7.44178 3.14457 7.45725 3.08691 7.45725Z",
    fill: "#BB8A1A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    opacity: 0.5,
    d: "M9.47381 7.45725H8.54925C8.49162 7.45725 8.43767 7.4418 8.39127 7.4154H8.39062V7.75285C8.39062 7.88306 8.50316 7.99001 8.64011 7.99001H9.38297C9.51993 7.99001 9.63246 7.88306 9.63246 7.75285V7.4154H9.63181C9.58541 7.44178 9.53147 7.45725 9.47383 7.45725H9.47381Z",
    fill: "#BB8A1A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    opacity: 0.5,
    d: "M3.08686 5.95932H2.79954C2.97006 5.95932 3.10982 6.09216 3.10982 6.25491V7.16167C3.10982 7.32442 2.97006 7.45727 2.79954 7.45727H3.08686C3.25738 7.45727 3.39713 7.32442 3.39713 7.16167V6.25491C3.39713 6.09216 3.25738 5.95932 3.08686 5.95932Z",
    fill: "#BB8A1A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    opacity: 0.5,
    d: "M9.47393 5.95932H9.18661C9.35714 5.95932 9.49689 6.09216 9.49689 6.25491V7.16167C9.49689 7.32442 9.35714 7.45727 9.18661 7.45727H9.47393C9.64445 7.45727 9.78421 7.32442 9.78421 7.16167V6.25491C9.78421 6.09216 9.64445 5.95932 9.47393 5.95932Z",
    fill: "#BB8A1A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M3.24499 7.41544C3.19859 7.44181 3.14464 7.45729 3.08699 7.45729H2.95901V7.75291C2.95901 7.88312 2.84648 7.99006 2.70881 7.99006H2.99612C3.1338 7.99006 3.24633 7.88312 3.24633 7.75291V7.41546H3.24497L3.24499 7.41544Z",
    fill: "#B48946"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M9.63208 7.41544C9.58568 7.44181 9.53174 7.45729 9.4741 7.45729H9.34541V7.75291C9.34541 7.88312 9.23288 7.99006 9.09592 7.99006H9.38324C9.52019 7.99006 9.63273 7.88312 9.63273 7.75291V7.41546H9.63208V7.41544Z",
    fill: "#B48946"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProTraceIcon);
export default __webpack_public_path__ + "static/media/pro-trace-icon.2b5d737dd46e4b5600f39b3976e09308.svg";
export { ForwardRef as ReactComponent };